import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("qru_cart")) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem("qru_cart", JSON.stringify(items)); }, [items]);

  const add = (product) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product_key === product.product_key);
      if (found) return prev.map((i) => i.product_key === product.product_key ? { ...i, quantity: i.quantity + 1 } : i);
      return [...prev, { product_key: product.product_key, title: product.title, price: product.price, cover_url: product.cover_url, quantity: 1 }];
    });
    setOpen(true);
  };
  const remove = (key) => setItems((prev) => prev.filter((i) => i.product_key !== key));
  const clear = () => setItems([]);
  const count = items.reduce((n, i) => n + i.quantity, 0);
  const subtotal = items.reduce((n, i) => n + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, clear, count, subtotal, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}
